(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["perspective"] && !Shopify.designMode) return;
  try {
    
(function() {
    const sectionId = 'perspective-{{ section.id }}';
    const container = document.getElementById(sectionId);
    if (!container) return;

    function updatePerspectiveClock() {
        const now = new Date();
        const timeString = now.toLocaleTimeString([], { 
            hour12: false, 
            hour: '2-digit', 
            minute: '2-digit', 
            second: '2-digit' 
        });
        const clockElements = container.querySelectorAll('.perspective-clock');
        clockElements.forEach(el => el.textContent = timeString);
    }

    setInterval(updatePerspectiveClock, 1000);
    updatePerspectiveClock();
})();

  } catch(e) { console.error(e); }
})();
})();
